import { Button, Card, Flex } from '@wyz/ui';
import { useFormContext } from 'react-hook-form';
import { Trans } from '~/common/context';
import { ICustomerCriteriaForm } from '~/connect/types';

type Props = {
  isLoading: boolean;
  onCancel: () => void;
};
export default function CustomersEditFormActions({
  onCancel,
  isLoading,
}: Props) {
  const methods = useFormContext<Pick<ICustomerCriteriaForm, 'criteria'>>();

  return (
    <Card className='mt-1'>
      <Card.Body>
        <Flex justifyContent={'end'} className='space-x-2'>
          <Button
            type='button'
            id='cancel'
            variant='link'
            disabled={isLoading}
            onClick={() => {
              // reset values
              methods.reset();
              // toggle edit mode
              onCancel();
            }}
          >
            <Trans i18nKey='app.common.button.cancel' />
          </Button>
          <Button
            type='submit'
            id='submit'
            variant='primary'
            isLoading={isLoading}
          >
            <Trans i18nKey='app.common.button.save' />
          </Button>
        </Flex>
      </Card.Body>
    </Card>
  );
}
